/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { housingControllerCreate } from '../fn/housing/housing-controller-create';
import { HousingControllerCreate$Params } from '../fn/housing/housing-controller-create';
import { housingControllerDelete } from '../fn/housing/housing-controller-delete';
import { HousingControllerDelete$Params } from '../fn/housing/housing-controller-delete';
import { housingControllerFindAll } from '../fn/housing/housing-controller-find-all';
import { HousingControllerFindAll$Params } from '../fn/housing/housing-controller-find-all';
import { housingControllerFindAllDropdown } from '../fn/housing/housing-controller-find-all-dropdown';
import { HousingControllerFindAllDropdown$Params } from '../fn/housing/housing-controller-find-all-dropdown';
import { housingControllerFindOne } from '../fn/housing/housing-controller-find-one';
import { HousingControllerFindOne$Params } from '../fn/housing/housing-controller-find-one';
import { housingControllerRestore } from '../fn/housing/housing-controller-restore';
import { HousingControllerRestore$Params } from '../fn/housing/housing-controller-restore';
import { housingControllerUpdate } from '../fn/housing/housing-controller-update';
import { HousingControllerUpdate$Params } from '../fn/housing/housing-controller-update';
import { HousingDto } from '../models/housing-dto';
import { HousingListItemDto } from '../models/housing-list-item-dto';
import { NameDto } from '../models/name-dto';
import { PaginatedDto } from '../models/paginated-dto';

@Injectable({ providedIn: 'root' })
export class HousingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `housingControllerFindAll()` */
  static readonly HousingControllerFindAllPath = '/api/housing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindAll$Response(params: HousingControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<HousingListItemDto>;
}>> {
    const obs = housingControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindAll(params: HousingControllerFindAll$Params, context?: HttpContext): Observable<PaginatedDto & {
'items'?: Array<HousingListItemDto>;
}> {
    const resp = this.housingControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PaginatedDto & {
'items'?: Array<HousingListItemDto>;
}>): PaginatedDto & {
'items'?: Array<HousingListItemDto>;
} => r.body)
    );
  }

  /** Path part for operation `housingControllerCreate()` */
  static readonly HousingControllerCreatePath = '/api/housing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  housingControllerCreate$Response(params: HousingControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<HousingDto>> {
    const obs = housingControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  housingControllerCreate(params: HousingControllerCreate$Params, context?: HttpContext): Observable<HousingDto> {
    const resp = this.housingControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HousingDto>): HousingDto => r.body)
    );
  }

  /** Path part for operation `housingControllerUpdate()` */
  static readonly HousingControllerUpdatePath = '/api/housing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  housingControllerUpdate$Response(params: HousingControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<HousingDto>> {
    const obs = housingControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  housingControllerUpdate(params: HousingControllerUpdate$Params, context?: HttpContext): Observable<HousingDto> {
    const resp = this.housingControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HousingDto>): HousingDto => r.body)
    );
  }

  /** Path part for operation `housingControllerFindAllDropdown()` */
  static readonly HousingControllerFindAllDropdownPath = '/api/housing/dropdown';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerFindAllDropdown()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindAllDropdown$Response(params: HousingControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<NameDto>>> {
    const obs = housingControllerFindAllDropdown(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerFindAllDropdown$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindAllDropdown(params: HousingControllerFindAllDropdown$Params, context?: HttpContext): Observable<Array<NameDto>> {
    const resp = this.housingControllerFindAllDropdown$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<NameDto>>): Array<NameDto> => r.body)
    );
  }

  /** Path part for operation `housingControllerFindOne()` */
  static readonly HousingControllerFindOnePath = '/api/housing/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindOne$Response(params: HousingControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<HousingDto>> {
    const obs = housingControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerFindOne(params: HousingControllerFindOne$Params, context?: HttpContext): Observable<HousingDto> {
    const resp = this.housingControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<HousingDto>): HousingDto => r.body)
    );
  }

  /** Path part for operation `housingControllerDelete()` */
  static readonly HousingControllerDeletePath = '/api/housing/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerDelete$Response(params: HousingControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = housingControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerDelete(params: HousingControllerDelete$Params, context?: HttpContext): Observable<void> {
    const resp = this.housingControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `housingControllerRestore()` */
  static readonly HousingControllerRestorePath = '/api/housing/restore/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `housingControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerRestore$Response(params: HousingControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = housingControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `housingControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  housingControllerRestore(params: HousingControllerRestore$Params, context?: HttpContext): Observable<void> {
    const resp = this.housingControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
